module.exports = __webpack_public_path__ + "img/nodrinkin.2e45d70a.png";